import { render, staticRenderFns } from "./prcm.vue?vue&type=template&id=e2e0596a&scoped=true&"
import script from "./prcm.vue?vue&type=script&lang=js&"
export * from "./prcm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e0596a",
  null
  
)

export default component.exports